module.exports = __webpack_public_path__ + "static/media/DougKeeper.c8c44946.png";